

<template>
<!-- <keep-alive> -->
  <component :is="currentView" ref="component"></component>
<!-- </keep-alive> -->
</template>

<script>
import { param } from "@/d";
import Preload from "@/component/Preload.vue";
import P1 from "@/component/P1";
import P3 from "@/component/P3";
import P4 from "@/component/PageStack";
import P5 from "@/component/P5";

const components = {Preload, P1, P3, P4, P5 };

export default {
  data() {
    return {
      currentView: null
    };
  },

  created() {
    let p = param(window.location.search, "p");
    if (this.currentView) return;
    let view = Preload;
    if (p) {
      view = components[p];
    }
    this.currentView = view;
  },

  mounted() {
    this.$root.$on("SwitchTo", this.SwitchTo);
  },

  beforeDestroy() {
    this.$root.$off("SwitchTo", this.SwitchTo);
  },

  methods: {
    SwitchTo(pageName) {
      this.currentView = components[pageName];
      // setTimeout(() => {
      //   if (this.$refs.component.onShow) {
      //     this.$refs.component.onShow();
      //   }
      // }, 50);
    }
  },

  components
};
</script>

<style lang="scss">
</style>
